/**
 * @fileoverview Provides default values for our custom types.
 *
 * NOTE: Please don't import this file directly, but use the index file instead.
 */
import type { ModelId } from "@/Reinforced.Typings.CustomTypes";

/**
 * Provides a default Model ID of a model defined in the backend in the namespace Miaplaza.Model.
 *
 * @remarks
 * Guarantees to always return the same string for the same `T`.
 *
 * @returns A default Model ID for the given type `T`.
 */
export function defaultModelId<T>(): ModelId<T> {
	return "00000000-0000-0000-0000-000000000000" as ModelId<T>;
}
